import React from 'react';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';

/* pages */
import { Top, Worries, Terms, Interview, News, PmanComic, About, NewsList, SupportersVoice, Faq } from './pages';
import { ScrollTop } from 'lib/scrill-to-top';

import './assets/styles/base.scss';

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Top />} />
        <Route path="/worries" element={<Worries />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/interview" element={<Interview />} />
        <Route path="/news" element={<News />} />
        <Route path="/news-list" element={<NewsList />} />
        <Route path="/p-man-comic" element={<PmanComic />} />
        <Route path="/about" element={<About />} />
        <Route path="/supporters-voice" element={<SupportersVoice />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
